import DownloadIcon from "components/icons/download-icon";
import { $t, t_key } from "plugins/i18n";
import React, { useContext, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { ModalProviderContext } from "../modal-provider";
import BackendApi from "backend-api";
import BackendConfig from "backend-config";

const AUTO_LEAVE_MS = 15_000;

type UnderageRegistrationSuccessProps = {
  containerId?: string;
  onLeave: () => void;
};

const UnderageRegistrationSuccessModal = (props: UnderageRegistrationSuccessProps) => {
  const { hideModal } = useContext(ModalProviderContext);
  const leftRef = useRef(false);

  const leave = () => {
    if (leftRef.current) {
      return;
    }
    leftRef.current = true;
    hideModal();
    props.onLeave();
  };

  useEffect(() => {
    const timerId = window.setTimeout(leave, AUTO_LEAVE_MS);
    return () => window.clearTimeout(timerId);
  }, []);

  const downloadContainer = () => {
    if (!props.containerId) {
      return;
    }
    BackendApi.getAndDownload(
      BackendConfig.Url() + `/siGa/DownloadContainer?cacheKey=${props.containerId}`,
      `${$t(t_key.signing_method_modal.signed_documents)}.bdoc`
    );
  };

  const isSigned = !!props.containerId;

  return (
    <Modal show onHide={leave} className="ra-modal success-modal" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {$t(t_key.underage_registration_success_modal.title)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          {isSigned
            ? $t(t_key.underage_registration_success_modal.body_signed)
            : $t(t_key.underage_registration_success_modal.body)}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {isSigned && (
          <Button
            variant="secondary"
            className="d-flex align-items-center btn-icon-left"
            onClick={downloadContainer}
          >
            <DownloadIcon />
            <span>{$t(t_key.signing_method_modal.signed_documents)}</span>
          </Button>
        )}
        <Button variant="primary" onClick={leave}>
          {$t(t_key.underage_registration_success_modal.continue)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnderageRegistrationSuccessModal;
